module.exports = __webpack_public_path__ + "img/public-sector.b972e697.svg";